import {Component, Input} from '@angular/core';

@Component({
  selector: 'digires-chevron-horizontal',
  templateUrl: './chevron-horizontal.component.html',
  styleUrls: ['./chevron-horizontal.component.scss']
})
export class ChevronHorizontalComponent {

  @Input() label: string;
  @Input() highlight: boolean;
  @Input() minWidth = '220px';
  @Input() fontSize = 'medium';

}
